;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	
	var Model = APP.module('Model');

	Model.MenuItem = Backbone.Model.extend({
		defaults: {
			method_name: '',
			name: '',
			icon: '',
			path: '',
			className: '',
			is_active: false,
			breadcrumb: false,
			nested_method_name: false,
			open_sub_menu_status: false,
			sub_menu: false,
			sub_menus_list: false
		},

		_setSubMenuItemState: function(state, value, key){


				if(value.method_name === state ||  this._checkStateForTernaryMenu(value, state)){

					value.is_active_sub = true;

					if(value.sub_menu){

						value.sub_menu = _.chain(value.sub_menu)
											.mapObject(this._setSubMenuItemState.bind(this, state))
											.toArray()
											.value();

					}

				}
				else {

					value.is_active_sub = false;

				}

			return value;
		},

		_checkStateForTernaryMenu: function(value, state){

				if(value.nested_method_name){

					var result = _.find(value.nested_method_name, function(value){

						return value == state;
					});

				}

			return Boolean(result)
		},

		isCurrentMenu: function(state){
			var find_sub_menu = this.findInSubMenu(state) || this.findNestedStates(state);

			if(find_sub_menu){

				this.setSubMenu(find_sub_menu, state);

			}

			return Boolean(find_sub_menu) || this.get('method_name') === state;
		},

		setSubMenu: function(find_sub_menu , state){

			var sub_menu = _.mapObject(find_sub_menu.menu, this._setSubMenuItemState.bind(this, state));

			_.keys(sub_menu).length && this.set({
				sub_menu: sub_menu,
				breadcrumb: find_sub_menu.breadcrumb,
				open_sub_menu_status: find_sub_menu.open_sub_menu_status
			});

		},

		findInSubMenu: function(state){
			return _.filter(this.get('sub_menus_list'), _.bind(this.filterSubMenuList, this , state)).pop();
		},

		filterSubMenuList: function(state, sub_menu, index){

			var menu = _.findWhere(sub_menu.menu, { method_name: state});

			if(menu){
				return sub_menu;
			}
			else{
				return this.findNestedSubMethodName(state, sub_menu);
			}

		},

		findNestedSubMethodName: function(state, sub_menu){

			if(Boolean(~_.indexOf(sub_menu.nested_method_name, state))){
				return sub_menu.menu;
			}
			else {
				return false;
			}

		},

		findNestedStates: function(state){
			var nested = this.get('nested_method_name');
			return _.contains(nested, state);
		},

		setBreadcrumb: function(obj){

			var find_sub_menu = this.findInSubMenu(obj.method_name);

			if(find_sub_menu){

				return { path: obj.path , text: obj.text };
			}

			return false;
		},

		hideItemSubMenuItem: function(item_method){

			var current_method = this.get('sub_menu');

			_.each(current_method, function(value){
				value.hide_item = false;
			});

			var set_hidden_item = _.map(current_method, function(value){

				if(Boolean(~_.indexOf(item_method, value.method_name))){

					value.hide_item = true;

				}

				return value;
			});

			this.set('sub_menu', set_hidden_item);

		},

		replaceState: function(replace_params, is_from_mobile){


			var modelItem = this.followRecursionInObject(this.toJSON(), _.bind(this.findPath, this), replace_params, is_from_mobile);

			this.set('sub_menu', modelItem.sub_menu);



		},

		followRecursionInObject: function(items, callback, context, is_from_mobile) {
			
			_.forEach(items, function (val, key ) {

				if ( this.deprecatedProperties(val, key) ) {

					callback(val, key, items, context, is_from_mobile);
					this.followRecursionInObject(val, callback, context, is_from_mobile);

				}

			}, this);

			return items;
		},

		deprecatedProperties: function(val, key){

			var deprecated_properties = ['sub_menus_list', 'breadcrumb', 'nested_method_name', 'menu'];

			return !Boolean(~_.indexOf(deprecated_properties, key)) && _.isObject(val);
		},

		findPath: function(val, key, items, context, is_from_mobile){


			val = this.replacePath(val, key, context, is_from_mobile);



			return val
		},

		replacePath: function(val, key, context, is_from_mobile){

			if(val.path && Boolean(~val.path.indexOf(context.param))){
				val.path = val.path.replace(context.param, context.replace_to);

			}

			return val;
		},

		setNameByCommisioner: function() {
			let name             = this.get('name'),
				commissioner_name = this.get('name_commisioner'),
				current_method   = this.get('sub_menu'),

				set_hidden_item  = _.map(current_method, function(value) {

					let name             = value.name,
						commisioner_name = value.name_commisioner;

					value.name = commisioner_name || name;
					value.old_name = name;

					return value;
				});

			this.set('name', commissioner_name || name);
			this.set('old_name', name);

			this.set('sub_menu', set_hidden_item);

		},
	});


}(window, APP, Backbone, Marionette, $, _));